module.exports = __webpack_public_path__ + "img/signature.d99d21ee.svg";